import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox_empty",
  "use": "checkbox_empty-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 20 20\" id=\"checkbox_empty\"><rect width=\"19\" height=\"19\" x=\".5\" y=\".5\" class=\"checkboxempty1\" rx=\"4\" ry=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol